import { Component, EventEmitter, Input, Output, inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { AuthenticationService } from '@/app/core/service/auth.service'
import { AuthenticatedUserService } from '@/app/core/service/authenticated-user.service'
import { SweetAlertService } from '@/app/core/service/sweet-alert.service'

@Component({
  selector: 'app-termo-confidencialidade',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './termo-confidencialidade.component.html',
  styleUrl: './termo-confidencialidade.component.scss',
})
export class TermoConfidencialidadeComponent {
  @Output() aceito = new EventEmitter<void>()
  @Output() fecharConsulta = new EventEmitter<void>()

  @Input() modoConsulta = false
  @Input() aceiteRegistrado = false
  @Input() dataAceite: string | null = null

  private authService = inject(AuthenticationService)
  private authenticatedUser = inject(AuthenticatedUserService)
  private swal = inject(SweetAlertService)

  aceitouTermos = false
  confirmando = false

  onFecharConsulta(): void {
    this.fecharConsulta.emit()
  }

  onConfirmar(): void {
    if (!this.aceitouTermos || this.confirmando) return

    this.confirmando = true

    this.authService.marcarLeuTermosConfidencialidade().subscribe({
      next: () => {
        const usuario = this.authenticatedUser.user()
        if (usuario) {
          this.authenticatedUser.setUser({ ...usuario, leuTermosConfidencialidade: true })
        }
        this.confirmando = false
        this.aceito.emit()
      },
      error: () => {
        this.confirmando = false
        this.swal.erro('Erro ao confirmar aceite', 'Não foi possível registrar sua confirmação. Tente novamente.')
      },
    })
  }
}
